// import { useState } from 'react';

import FrameSection from '../../../components/dnd/FrameSection';

type ArmorData = {
    id: string;
    name: string;
};

type ArmorProps = {
    items: ArmorData[];
};

function Armor({
    items
}: ArmorProps) {
    // const [armor, setArmor] = useState<ArmorData[]>(items);

    return (
        <>
            <FrameSection title="Armor" />
        </>
    );
}

export default Armor;